<template>
  <div class="plannav">
    <p class="title">↓【诸.葛.亮】期期推荐 免费资料↓</p>
    <ul v-if="qi">
      <li
        v-for="(item, index) in list"
        :key="item.com"
        @click="gourl(item.com)"
      >
        {{ qi }}期：诸葛亮
        <span style="color: red">【{{ item.label }}】</span> 期期公开
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { myHttp } from "../request/index";

const qi = ref(null);
function load() {
  myHttp("/api/liuhe/queryLast").then((res) => {
    console.log(res);
    if (res.success) {
      qi.value = res.data.number;
    }
  });
}
load();

const list = ref([
  { label: "九七五三一肖中", com: "jiuqiwusanyi" },
  { label: "一表人才单双", com: "danShuang" },
  { label: "24码中特", com: "code24" },
  { label: "5尾必中", com: "wuweibizhong" },
  { label: "大小中特", com: "daXiaoShu" },
  { label: "三头中特", com: "tou" },
  { label: "6肖12码", com: "liumashierxiao" },
  { label: "买啥开啥", com: "heshudanshuang" },  //合数单双
  { label: "家禽野兽", com: "jiaqingyeshou" },
  { label: "左右肖", com: "zuoyouxiao" },
  { label: "绝杀三肖", com: "sanXiao" },
  { label: "前后中特", com: "qianHou" },
  { label: "平特三连肖", com: "pingtesanxiao" },
  { label: "双波中奖", com: "wenzhuan2bo" },
  { label: "内幕12码", com: "neimushierma" },
]);

const router = useRouter();
function gourl(e) {
  router.push({ path: "/plan", query: { com: e } });
}
</script>

<style lang="scss" scoped>
.plannav {
  .title {
    padding: 12px;
    text-align: center;
    color: red;
    font-size: 22px;
    font-weight: bold;
    background: linear-gradient(to right, #9dafc7, #e7e9ed, #62677a);
  }
  ul {
    border: 2px solid #bdc0d1;
    li {
      padding: 6px 13px;
      border-bottom: 2px solid #bdc0d1;
      font-weight: bold;
      box-shadow: 0 0 10px 0 #ccc;
      border-radius: 12px;
      margin: 3px;
      text-decoration: underline;
      &:nth-child(2n) {
        color: rgb(211, 10, 43);
      }
      &:nth-child(9n) {
        color: rgb(6, 9, 241);
      }
      &:nth-child(7n) {
        color: rgb(60, 166, 3);
      }
    }
  }
}
</style>